import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
	colors: {
		gray: {
			700: '#1f2733'
		}
	},
	styles: {
		global: (props) => ({
			body: {
			    bg: "linear-gradient(          rgb(0 0 0 / 2%),           rgb(108 39 0 / 43%)        ),url(https://www.copyrighthistory.org/cam/graphix/bg.jpg)",
//				bg: mode('gray.50', 'gray.800')(props),
				fontFamily: "'Roboto', sans-serif"
			},
			html: {
				fontFamily: "'Roboto', sans-serif"
			}
		})
	}
};
